import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';

export const SegmentContainer = styled.div`
	margin-top: 1.5rem;
	padding: 0 1rem;

	ion-segment.ios {
		border-radius: 20px;
	}
	ion-segment-button {
		color: var(--ion-color-primary);
		transition: color 0.25s;
		text-transform: none;
		font-family: var(--body-font);
		font-weight: 500;
	}
	ion-segment-button::part(indicator-background) {
		background: var(--ion-color-secondary);
	}
	/* Material Design styles */
	ion-segment-button.md::part(native) {
		color: var(--ion-color-primary);
	}

	.segment-button-checked.md::part(native) {
		color: var(--ion-color-primary);
	}

	ion-segment-button.md::part(indicator-background) {
		height: 2px;
	}

	/* iOS styles */
	ion-segment-button.ios::part(native) {
		color: var(--ion-color-primary);
	}

	.segment-button-checked.ios::part(native) {
		color: #fff;
	}

	ion-segment-button.ios::part(indicator-background) {
		border-radius: 20px;
	}
`;

export const MediaGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
	margin-top: 1.5rem;
	margin-bottom: 3rem;
	padding: 0 1rem;
`;

export const MediaThumb = styled.div`
	background-color: var(--bg-300);
	border-radius: 10px;
	overflow: hidden;
	aspect-ratio: 1/1;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	position: relative;
`;
export const MediaThumbImg = styled(LoadingImage)`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
`;

export const VideoIconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0.8;

	svg {
		path {
			fill: #fff;
		}
	}
`;

export const MediaSwiperContainer = styled.div`
	background-color: var(--ion-color-step-950);
	width: 100%;
	/* height: 500px; */
	/* padding: 3rem 0 2rem; */
`;

export const MediaSwiper = styled(Swiper)`
	/* border: 1px solid red; */
`;

export const MediaSwiperSlide = styled(SwiperSlide)`
	/* border: 1px solid blue; */
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100svh;
	padding: 1rem;
`;

export const MediaImageContainer = styled.div`
	position: relative;
	border-radius: 5px 5px 5px 5px;
	overflow: hidden;
	box-shadow: var(--generic-box-shadow);
	/* width: calc(100% - 2rem); */
	& > div {
		position: relative;
	}
	img {
		position: relative;
		width: 100%;
		height: 100%;
		display: block;
	}
`;
